module.exports = __webpack_public_path__ + "img/pug.f0b80150.gif";